import Script from "../Script";
import UIManifest from "src/engine/ui/UIManifest";
// import Utils from "src/lib/utils/Utils";

interface IUrlScript {
    //*xxx*
    formmatter: string[];
}

const LOCATION_KEY = ["hash", "host", "hostname", "href", "origin", "pathname", "port", "protocol", "search"];

/**
 * @class UrlScript
 */
@UIManifest.declare("UrlScript", "获取Url脚本", UIManifest.Type.Script)
export default class UrlScript extends Script<IUrlScript> {
    private getUrl(type: string[], value: any) {
        const location = window.location;
        let url = "";
        for (const str of type) {
            if (LOCATION_KEY.indexOf(str) >= 0) {
                url += location[str];
            } else if (str === "xxx") {
                url += value;
            } else {
                url += str;
            }
        }
        return url;
    }

    handle(value: any) {
        const { formmatter } = this.props;
        if (formmatter) {
            return this.getUrl(formmatter, value !== undefined ? value : "xxx");
        }
        return value;
    }
}
